import { https } from "@/lib/fetchService";

export interface User {
  id: string;
  email: string;
  name?: string;
  emailVerified: boolean;
  createdAt: string;
  updatedAt: string;
  organizations: {
    id: string;
    name: string;
  }[];
}

export interface Session {
  id: string;
  token: string;
  expiresAt: string;
  userId: string;
  createdAt: string;
  updatedAt: string;
}

export interface SessionResponse {
  user: User;
  session: Session;
}

export interface SendOtpParams {
  email: string;
  type: "sign-in";
}

export interface VerifyOtpParams {
  email: string;
  otp: string;
}

export interface LoginResponse {
  token: string;
  user: {
    id: string;
    email: string;
    name?: string;
  };
}

export const getSession = () =>
  https.get<SessionResponse | null>({ url: "/auth/get-session" });

export const signOut = () => https.post({ url: "/auth/sign-out" });

// Login via otp
export const sendVerificationOtp = (params: SendOtpParams) =>
  https.post({ url: "/auth/email-otp/send-verification-otp", body: params });

export const verifyEmailOtp = (params: VerifyOtpParams) =>
  https.post({ url: "/auth/sign-in/email-otp", body: params });
